import { render, staticRenderFns } from "./AdviceList.vue?vue&type=template&id=8e69c89c&scoped=true&"
import script from "./AdviceList.vue?vue&type=script&lang=js&"
export * from "./AdviceList.vue?vue&type=script&lang=js&"
import style0 from "./AdviceList.vue?vue&type=style&index=0&id=8e69c89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e69c89c",
  null
  
)

export default component.exports